import { Component } from '@angular/core'
import { DesktopDownloadUrlService } from '~app/features/desktop/desktop-download-url.service'
import { isInDesktopApp } from '~app/util/IsInDesktopApp'

@Component({
  selector: 'ftr-footer-help-links',
  templateUrl: './footer-help-links.component.html',
  styleUrls: ['./footer-help-links.component.css'],
})
export class FooterHelpLinksComponent {
  downloadAppUrl: string
  showDesktopDownloadLink = !isInDesktopApp()

  constructor(private readonly desktopDownloadUrlService: DesktopDownloadUrlService) {
    this.downloadAppUrl = this.desktopDownloadUrlService.getDownloadUrl()
  }
}
